export const moduleName = "delete-campaign";
